export const NAME = 'Account';



// WEBPACK FOOTER //
// ./modules/Account/redux/constants.js